module.exports = __webpack_public_path__ + "static/media/home-store-logo-black.11205c8e.svg";